import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client'

class LandingPageConfig extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'LandingPageConfig'
  // Define default properties here
  static instanceDefaults() {
    return {
    }
  }
}
const servicePath = 'landing-page-config'
const servicePlugin = makeServicePlugin({
  Model: LandingPageConfig,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin